
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.3646 17.7524L22.2319 17.4395C21.7802 16.2647 21.0066 15.2544 20.0074 14.5344C19.0083 13.8144 17.8279 13.4166 16.6132 13.3906H10.7002C9.48581 13.4164 8.30554 13.8141 7.30658 14.5339C6.30762 15.2537 5.53414 16.2638 5.08257 17.4384L4.93956 17.7728C4.71419 18.3092 4.6192 18.8952 4.66298 19.479C4.70677 20.0627 4.88799 20.6262 5.19061 21.1197C5.43966 21.5389 5.78672 21.8853 6.19933 22.1268C6.61193 22.3682 7.07659 22.4966 7.54982 22.5001H19.7451C20.2198 22.4966 20.6859 22.3678 21.0997 22.1256C21.5136 21.8835 21.8617 21.5359 22.1115 21.1154C22.4157 20.6197 22.5979 20.0535 22.6421 19.4669C22.6862 18.8803 22.5909 18.2915 22.3646 17.7524Z","fill":"#5D5CFD"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.657 10.19C15.6425 10.19 17.252 8.58046 17.252 6.595C17.252 4.60954 15.6425 3 13.657 3C11.6715 3 10.062 4.60954 10.062 6.595C10.062 8.58046 11.6715 10.19 13.657 10.19ZM18.752 6.595C18.752 9.40889 16.4709 11.69 13.657 11.69C10.8431 11.69 8.56201 9.40889 8.56201 6.595C8.56201 3.78111 10.8431 1.5 13.657 1.5C16.4709 1.5 18.752 3.78111 18.752 6.595ZM5.29188 5.31494C5.93628 5.31494 6.46254 5.8412 6.46254 6.48561V6.58227C6.46254 7.22667 5.93628 7.75293 5.29188 7.75293C4.64748 7.75293 4.12122 7.22667 4.12122 6.58227V6.48561C4.12122 5.8412 4.64748 5.31494 5.29188 5.31494ZM3.68874 16.4856C3.68874 15.8412 3.16248 15.3149 2.51808 15.3149C1.87367 15.3149 1.34741 15.8412 1.34741 16.4856V16.5823C1.34741 17.2267 1.87367 17.7529 2.51808 17.7529C3.16248 17.7529 3.68874 17.2267 3.68874 16.5823V16.4856Z","fill":"#16171F"}})])
          )
        }
      }
    